import { render } from "./ShippingDetailModal.vue?vue&type=template&id=0ec306eb&scoped=true"
import script from "./ShippingDetailModal.vue?vue&type=script&lang=js"
export * from "./ShippingDetailModal.vue?vue&type=script&lang=js"

import "./ShippingDetailModal.vue?vue&type=style&index=0&id=0ec306eb&scoped=true&lang=css"

import exportComponent from "/builds/weborigo-projects/vivien-vance/core-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ec306eb"]])

export default __exports__